define('modules/start/index',['require','exports','module','./collection','./products-report-model','./products/email/status/model','./view'],function (require, exports, module) {
  "use strict";

  module.exports = {
    Products: require("./collection"),
    ProductsReport: require("./products-report-model"),
    MDirectorDetailsModel: require("./products/email/status/model"),
    View: require("./view"),
  };
});

